/** Shared text styles. Stock Tailwind sizes only, so cn()/tailwind-merge classifies them correctly. */
/** Page title (h1): 24/30 on phones, 30/36 from 640px. Wraps; never truncates. */
export const pageTitleClassName =
    'break-words text-2xl font-semibold leading-tight text-neutral-950 sm:text-3xl';

/** Small all-caps caption (card header captions, stat/field eyebrows). Wider tracking keeps 12px caps legible. */
export const overlineClassName =
    'text-xs font-semibold uppercase tracking-wider text-muted-foreground';

/** Section heading (h2 on a page or at the top of a card): 20/25. */
export const sectionTitleClassName = 'text-xl font-semibold leading-tight text-neutral-950';

/** Card or group title: 16/22. */
export const cardTitleClassName = 'text-base font-semibold leading-snug text-neutral-950';

/** Dialog title (h2): 20/25. */
export const dialogTitleClassName = 'text-xl font-semibold leading-tight text-neutral-950';

/** Field label above a read-only value. */
export const fieldLabelClassName = 'text-sm text-neutral-500';

/** Read-only field value under a label. */
export const fieldValueClassName = 'mt-1 break-words text-sm font-medium text-neutral-950';
